export default  {	
	data () {
		return { 
			filter: {
				name: null,
				id_list: null,
				id_datos_razon: null,
				id_datos_asesor: null,
				id_datos_contacto: null,
				estado: ['Nuevo','Activo','Retiro'],
			},
			mes: null,
			ano: null,
			statusDescargar:false,			
			statusLoading: false
		}
	},
	async created () { 
		// solo frontend this.searchGetIdb({tabla:'afiliacion_registro'})
		this.mes= this.gettersDatalist('list_mes',this.fecha().fecha.mesHoy)[0]
		this.ano= this.gettersDatalist('list_ano',this.fecha().fecha.anoHoy)[0]
	},		
	computed: 
	{
		entidades() 
		{
			if(this.filter.name!=null)
			{
				switch(this.filter.name.name)
				{
					case 'Eps':
						return this.lists.list_eps
					break; 
					case 'Riesgo':
						return this.lists.list_riesgo
					break; 
					case 'Ccf':
						return this.lists.list_ccf
					break; 
					case 'Afp':
						return this.lists.list_afp
					break; 
					case 'Traslado':
						return this.lists.list_eps
					break; 
				}
				
			}
			return []
		}
	},
	destroyed()
	{
		this.resetCrud({state: 'dataGet/informes_aportes/data'})
	}
}
